(function() {
'use strict';

angular
    .module('TR')
    .directive('publicityMessages', function(arrayUtil, $interval, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                stats: '=',
                loop: '='
            },
            template: '<div class="publicity-messages"><p class="publicity-message"></p></div>',

            link(scope, el) {
                const fade = 500;
                const cycle = 5000;
                const p = el.find('p:first');
                let msgs;
                let i = 0;
                let loop;

                function showMsg() {
                    i += 1;
                    p.addClass('faded');
                    $timeout(function() {
                        p.text(msgs[i % msgs.length].Text);
                        p.removeClass('faded');
                    }, fade);
                }

                scope.$watch('loop', function(v, o) {
                    if (v == null || v === o) {
                        return;
                    }

                    $interval.cancel(loop);
                    if (v && msgs != null && msgs.length > 1) {
                        loop = $interval(showMsg, cycle);
                    }
                });

                const cancel = scope.$watch('stats', function(data) {
                    if (data != null) {
                        msgs = arrayUtil.filter([data.BookingsInLastHour, data.CustomersCurrentlyOnHoliday,
                                data.CustomersGoingOnHoliday, data.SearchesInLastHour], function(msg) {
                                    return msg != null && msg.Text != null && msg.Value > 1;
                                });
                        if (msgs.length > 0) {
                            p.text(msgs[i].Text);
                        }
                        cancel();
                    }
                });

                scope.$on('$destroy', function() {
                    $interval.cancel(loop);
                });
            }
        };
    });
})();
